import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLineIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26.173 29.019",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-0.254 0.793)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0,0,5,0,5,6.052l-5,0Z",
				transform: "translate(0.254 -0.793)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0,0H5V6.052H0Z",
				transform: "translate(21.427 22.173)"
			}),
			/* @__PURE__ */ _jsx("rect", {
				width: 2,
				height: 30,
				transform: "translate(2.287 2.515) rotate(-41)"
			})
		]
	})
});
export default SvgLineIcon;
